export const BRANDS = ['HP Gas', 'Bharat Gas', 'Indane'];
export const SIZES  = ['4 kg', '8 kg', '12 kg', '17 kg', '19 kg', '21 kg', '33 kg', '47.5 kg'];
